/**
 * Scroll Reveal — IntersectionObserver-based scroll animation system
 * Usage: add data-reveal to any element. Optional: data-reveal-delay="200" for stagger.
 */
document.addEventListener('DOMContentLoaded', function () {
  var elements = document.querySelectorAll('[data-reveal]');

  if (!elements.length) return;

  // Immediately hide all reveal elements
  elements.forEach(function (el) {
    el.classList.add('reveal-hidden');

    // Apply stagger delay if specified
    var delay = el.getAttribute('data-reveal-delay');
    if (delay) {
      el.style.transitionDelay = delay + 'ms';
    }
  });

  // Create observer
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
          entry.target.classList.remove('reveal-hidden');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }
  );

  // Observe all elements
  elements.forEach(function (el) {
    observer.observe(el);
  });
});
